import {
  Actor,
  CollisionType,
  Color,
  FontSource,
  ImageFiltering,
  ImageSource,
  Loader,
  Resource,
  Sound,
  Sprite,
  Vector,
} from "excalibur";
import { TiledResource } from "@excaliburjs/plugin-tiled";

// Import paths to work with Vite
// Note the ?url suffix

import charVeil from "./../res/charVeil.png";
import heroPath from "./../res/char.png";
import wood from "./../res/wood.png";
import grandpaPath from "./../res/grandpa.png";
import girl from "./../res/girlSprites.png";
import hippyChick from "./../res/hippyChickSprites.png";
import colin from "./../res/colinSprites.png";
import cowboy from "./../res/cowboySprites.png";
import farmerJackson from "./../res/farmerJacksonSprites.png";
import sparky from "./../res/sparkySprites.png";
import linda from "./../res/lindaSprites.png";
import bigBen from "./../res/bigBenSprites.png";
import farley from "./../res/farleySprites.png";
import kevin from "./../res/kevinSprites.png";
import marvin from "./../res/marvinSprites.png";
import ronald from "./../res/ronaldSprites.png";
import kaison from "./../res/kaisonSprites.png";
import kennedy from "./../res/kennedySprites.png";
import professor from "./../res/professorSprites.png";
import oldMan from "./../res/oldManSprites.png";
import oldLady from "./../res/oldLadySprites.png";
import katie from "./../res/bartenderAnims.png";

import hud from "./../res/gameUI.png";
import smallHives from "./../res/smallHives.png";
import bigHives from "./../res/bigHives.png";
import bees from "./../res/bees.png";
import swarm from "./../res/swarm.png";
import font from "/font/newPixel.ttf";
import logo from "/logoSmall.png";
import inspectBoxSprites from "./../res/inspectBoxSprite.png";
import frameCellSprites from "./../res/frameCellsSprite.png";
import queenCellSprites from "./../res/queenCells.png";
import extractor from "./../res/extractor.png";
import bottler from "./../res/bottler.png";
import honeyStand from "./../res/honeyStand.png";
import bottlingAnimation from "./../res/bottlingAnimation.png";
import appleCider from "/sounds/appleCider.ogg";
import menuSong from "/sounds/menuSong.mp3";
import click from "/sounds/click.wav";
import coin from "/sounds/coin.wav";
import coins from "/sounds/coins.wav";
import error from "/sounds/error.wav";
import liquid from "/sounds/liquid.ogg";
import won from "/sounds/won.wav";
import feed from "/sounds/feed.ogg";
import woodSound from "/sounds/addBox.wav";
import footsteps from "/sounds/footsteps.ogg";
import inventory from "/sounds/inventory.wav";
import beeSounds from "/sounds/bees.mp3";
import pullFrame from "/sounds/pullFrame.wav";
import grunt from "/sounds/grunt.wav";
import keyPress from "/sounds/keypress.wav";
import crickets from "/sounds/crickets.mp3";
export const Resources = {
  AppleCider: new Sound(appleCider),
  MenuSong: new Sound(menuSong),
  Crickets: new Sound(crickets),
  Click: new Sound(click),
  Coin: new Sound(coin),
  Coins: new Sound(coins),
  Error: new Sound(error),
  Liquid: new Sound(liquid),
  Won: new Sound(won),
  Feed: new Sound(feed),
  WoodSound: new Sound(woodSound),
  Footsteps: new Sound(footsteps),
  Inventory: new Sound(inventory),
  BeeSounds: new Sound(beeSounds),
  PullFrame: new Sound(pullFrame),
  Grunt: new Sound(grunt),
  Keypress: new Sound(keyPress),
  Font: new FontSource(font, "gameboy", {
    filtering: ImageFiltering.Pixel,
    size: 16,
  }),
  Wood: new ImageSource(wood, false, ImageFiltering.Pixel),

  Bees: new ImageSource(bees, false, ImageFiltering.Pixel),
  Swarm: new ImageSource(swarm, false, ImageFiltering.Pixel),
  SmallHives: new ImageSource(smallHives, false, ImageFiltering.Pixel),
  BigHives: new ImageSource(bigHives, false, ImageFiltering.Pixel),
  Hud: new ImageSource(hud, false, ImageFiltering.Pixel),
  CharVeil: new ImageSource(charVeil, false, ImageFiltering.Pixel),
  HeroSpriteSheetPng: new ImageSource(heroPath, false, ImageFiltering.Pixel),
  Extractor: new ImageSource(extractor, false, ImageFiltering.Pixel),
  Bottler: new ImageSource(bottler, false, ImageFiltering.Pixel),
  HoneyStand: new ImageSource(honeyStand, false, ImageFiltering.Pixel),
  BottlingAnimation: new ImageSource(
    bottlingAnimation,
    false,
    ImageFiltering.Pixel
  ),
  InspectBoxSprites: new ImageSource(
    inspectBoxSprites,
    false,
    ImageFiltering.Pixel
  ),
  FrameCellSprites: new ImageSource(
    frameCellSprites,
    false,
    ImageFiltering.Pixel
  ),
  QueenCellSprites: new ImageSource(
    queenCellSprites,
    false,
    ImageFiltering.Pixel
  ),
  GrandpaSpriteSheetPng: new ImageSource(
    grandpaPath,
    false,
    ImageFiltering.Pixel
  ),
  GirlSpriteSheet: new ImageSource(girl, false, ImageFiltering.Pixel),
  HippyChickSpriteSheet: new ImageSource(
    hippyChick,
    false,
    ImageFiltering.Pixel
  ),
  ColinSpriteSheet: new ImageSource(colin, false, ImageFiltering.Pixel),
  SparkySpriteSheet: new ImageSource(sparky, false, ImageFiltering.Pixel),
  LindaSpriteSheet: new ImageSource(linda, false, ImageFiltering.Pixel),
  BigBenSpriteSheet: new ImageSource(bigBen, false, ImageFiltering.Pixel),
  MarvinSpriteSheet: new ImageSource(marvin, false, ImageFiltering.Pixel),
  KevinSpriteSheet: new ImageSource(kevin, false, ImageFiltering.Pixel),
  FarleySpriteSheet: new ImageSource(farley, false, ImageFiltering.Pixel),
  RonaldSpriteSheet: new ImageSource(ronald, false, ImageFiltering.Pixel),
  FarmerJacksonSpriteSheet: new ImageSource(
    farmerJackson,
    false,
    ImageFiltering.Pixel
  ),
  CowboySpriteSheet: new ImageSource(cowboy, false, ImageFiltering.Pixel),
  KaisonSpriteSheet: new ImageSource(kaison, false, ImageFiltering.Pixel),
  KennedySpriteSheet: new ImageSource(kennedy, false, ImageFiltering.Pixel),
  ProfessorSpriteSheet: new ImageSource(professor, false, ImageFiltering.Pixel),
  OldManSpriteSheet: new ImageSource(oldMan, false, ImageFiltering.Pixel),
  OldLadySpriteSheet: new ImageSource(oldLady, false, ImageFiltering.Pixel),
  KatieSprites: new ImageSource(katie, false, ImageFiltering.Pixel),
  TiledMap: new TiledResource("./tiled/home.tmx", {
    entityClassNameFactories: {
      // player: (props) => {
      //   console.log("inside creating player");
      //   const player = new Player(props.worldPos);
      //   player.z = 2;
      //   return player;
      // },
      border: (props) => {
        return new Actor({
          anchor: new Vector(0, 0),
          pos: props.worldPos,
          width: props.object.width,
          height: props.object.height,
          collisionType: CollisionType.Fixed,
        });
      },
    },
    // Path map intercepts and redirects to work around vite's static bundling
    pathMap: [
      { path: "home.tmx", output: "./tiled/home.tmx" },
      { path: "homeSprites.png", output: "./tiled/homeSprites.png" },
      { path: "homeSprites.tsx", output: "./tiled/homeSprites.tsx" },
    ],
  }),
  HouseMap: new TiledResource("./tiled/house.tmx", {
    entityClassNameFactories: {
      border: (props) => {
        return new Actor({
          anchor: new Vector(0, 0),
          pos: props.worldPos,
          width: props.object.width,
          height: props.object.height,
          collisionType: CollisionType.Fixed,
        });
      },
    },
    // Path map intercepts and redirects to work around vite's static bundling
    pathMap: [
      { path: "house.tmx", output: "./tiled/house.tmx" },
      { path: "floors_walls.tsx", output: "./tiled/floors_walls.tsx" },
      { path: "floors_walls.png", output: "./tiled/floors_walls.png" },
      { path: "decorations.tsx", output: "./tiled/decorations.tsx" },
      { path: "decorations.png", output: "./tiled/decorations.png" },
      { path: "furniture.tsx", output: "./tiled/furniture.tsx" },
      { path: "furniture.png", output: "./tiled/furniture.png" },
      { path: "interiorSprites.png", output: "./tiled/interiorSprites.png" },
      { path: "interiorSprites.tsx", output: "./tiled/interiorSprites.tsx" },
    ],
  }),
  LindasHouse: new TiledResource("./tiled/lindasHouse.tmx", {
    entityClassNameFactories: {
      border: (props) => {
        return new Actor({
          anchor: new Vector(0, 0),
          pos: props.worldPos,
          width: props.object.width,
          height: props.object.height,
          collisionType: CollisionType.Fixed,
        });
      },
    },
    // Path map intercepts and redirects to work around vite's static bundling
    pathMap: [
      { path: "floors_walls.tsx", output: "./tiled/floors_walls.tsx" },
      { path: "floors_walls.png", output: "./tiled/floors_walls.png" },
      { path: "decorations.tsx", output: "./tiled/decorations.tsx" },
      { path: "decorations.png", output: "./tiled/decorations.png" },
      { path: "furniture.tsx", output: "./tiled/furniture.tsx" },
      { path: "furniture.png", output: "./tiled/furniture.png" },
    ],
  }),
  MarvinsHouse: new TiledResource("./tiled/marvins.tmx", {
    entityClassNameFactories: {
      border: (props) => {
        return new Actor({
          anchor: new Vector(0, 0),
          pos: props.worldPos,
          width: props.object.width,
          height: props.object.height,
          collisionType: CollisionType.Fixed,
        });
      },
    },
    // Path map intercepts and redirects to work around vite's static bundling
    pathMap: [
      { path: "floors_walls.tsx", output: "./tiled/floors_walls.tsx" },
      { path: "floors_walls.png", output: "./tiled/floors_walls.png" },
      { path: "decorations.tsx", output: "./tiled/decorations.tsx" },
      { path: "decorations.png", output: "./tiled/decorations.png" },
      { path: "furniture.tsx", output: "./tiled/furniture.tsx" },
      { path: "furniture.png", output: "./tiled/furniture.png" },
    ],
  }),
  KevinsHouse: new TiledResource("./tiled/kevinsHouse.tmx", {
    entityClassNameFactories: {
      border: (props) => {
        return new Actor({
          anchor: new Vector(0, 0),
          pos: props.worldPos,
          width: props.object.width,
          height: props.object.height,
          collisionType: CollisionType.Fixed,
        });
      },
    },
    // Path map intercepts and redirects to work around vite's static bundling
    pathMap: [
      { path: "floors_walls.tsx", output: "./tiled/floors_walls.tsx" },
      { path: "floors_walls.png", output: "./tiled/floors_walls.png" },
      { path: "decorations.tsx", output: "./tiled/decorations.tsx" },
      { path: "decorations.png", output: "./tiled/decorations.png" },
      { path: "furniture.tsx", output: "./tiled/furniture.tsx" },
      { path: "furniture.png", output: "./tiled/furniture.png" },
    ],
  }),
  BillsHouse: new TiledResource("./tiled/billsHouse.tmx", {
    entityClassNameFactories: {
      border: (props) => {
        return new Actor({
          anchor: new Vector(0, 0),
          pos: props.worldPos,
          width: props.object.width,
          height: props.object.height,
          collisionType: CollisionType.Fixed,
        });
      },
    },
    // Path map intercepts and redirects to work around vite's static bundling
    pathMap: [
      { path: "floors_walls.tsx", output: "./tiled/floors_walls.tsx" },
      { path: "floors_walls.png", output: "./tiled/floors_walls.png" },
      { path: "decorations.tsx", output: "./tiled/decorations.tsx" },
      { path: "decorations.png", output: "./tiled/decorations.png" },
      { path: "furniture.tsx", output: "./tiled/furniture.tsx" },
      { path: "furniture.png", output: "./tiled/furniture.png" },
    ],
  }),
  JacksonsHouse: new TiledResource("./tiled/jacksonsHouse.tmx", {
    entityClassNameFactories: {
      border: (props) => {
        return new Actor({
          anchor: new Vector(0, 0),
          pos: props.worldPos,
          width: props.object.width,
          height: props.object.height,
          collisionType: CollisionType.Fixed,
        });
      },
    },
    // Path map intercepts and redirects to work around vite's static bundling
    pathMap: [
      { path: "floors_walls.tsx", output: "./tiled/floors_walls.tsx" },
      { path: "floors_walls.png", output: "./tiled/floors_walls.png" },
      { path: "decorations.tsx", output: "./tiled/decorations.tsx" },
      { path: "decorations.png", output: "./tiled/decorations.png" },
      { path: "furniture.tsx", output: "./tiled/furniture.tsx" },
      { path: "furniture.png", output: "./tiled/furniture.png" },
    ],
  }),
  McCartysMap: new TiledResource("./tiled/mccartys.tmx", {
    entityClassNameFactories: {
      border: (props) => {
        return new Actor({
          anchor: new Vector(0, 0),
          pos: props.worldPos,
          width: props.object.width,
          height: props.object.height,
          collisionType: CollisionType.Fixed,
        });
      },
    },
    // Path map intercepts and redirects to work around vite's static bundling
    pathMap: [
      { path: "floors_walls.tsx", output: "./tiled/floors_walls.tsx" },
      { path: "floors_walls.png", output: "./tiled/floors_walls.png" },
      { path: "decorations.tsx", output: "./tiled/decorations.tsx" },
      { path: "decorations.png", output: "./tiled/decorations.png" },
      { path: "furniture.tsx", output: "./tiled/furniture.tsx" },
      { path: "furniture.png", output: "./tiled/furniture.png" },
    ],
  }),
  BigBensMap: new TiledResource("./tiled/bigBens.tmx", {
    entityClassNameFactories: {
      border: (props) => {
        return new Actor({
          anchor: new Vector(0, 0),
          pos: props.worldPos,
          width: props.object.width,
          height: props.object.height,
          collisionType: CollisionType.Fixed,
        });
      },
    },
    // Path map intercepts and redirects to work around vite's static bundling
    pathMap: [
      { path: "floors_walls.tsx", output: "./tiled/floors_walls.tsx" },
      { path: "floors_walls.png", output: "./tiled/floors_walls.png" },
      { path: "decorations.tsx", output: "./tiled/decorations.tsx" },
      { path: "decorations.png", output: "./tiled/decorations.png" },
      { path: "furniture.tsx", output: "./tiled/furniture.tsx" },
      { path: "furniture.png", output: "./tiled/furniture.png" },
      { path: "interiorSprites.png", output: "./tiled/interiorSprites.png" },
      { path: "interiorSprites.tsx", output: "./tiled/interiorSprites.tsx" },
    ],
  }),
  SparkysMap: new TiledResource("./tiled/sparkys.tmx", {
    entityClassNameFactories: {
      border: (props) => {
        return new Actor({
          anchor: new Vector(0, 0),
          pos: props.worldPos,
          width: props.object.width,
          height: props.object.height,
          collisionType: CollisionType.Fixed,
        });
      },
    },
    // Path map intercepts and redirects to work around vite's static bundling
    pathMap: [
      { path: "floors_walls.tsx", output: "./tiled/floors_walls.tsx" },
      { path: "floors_walls.png", output: "./tiled/floors_walls.png" },
      { path: "decorations.tsx", output: "./tiled/decorations.tsx" },
      { path: "decorations.png", output: "./tiled/decorations.png" },
      { path: "furniture.tsx", output: "./tiled/furniture.tsx" },
      { path: "furniture.png", output: "./tiled/furniture.png" },
      { path: "interiorSprites.png", output: "./tiled/interiorSprites.png" },
      { path: "interiorSprites.tsx", output: "./tiled/interiorSprites.tsx" },
    ],
  }),
  FurdlandMap: new TiledResource("./tiled/furdland.tmx", {
    entityClassNameFactories: {
      border: (props) => {
        return new Actor({
          anchor: new Vector(0, 0),
          pos: props.worldPos,
          width: props.object.width,
          height: props.object.height,
          collisionType: CollisionType.Fixed,
        });
      },
    },
    // Path map intercepts and redirects to work around vite's static bundling
    pathMap: [
      { path: "floors_walls.tsx", output: "./tiled/floors_walls.tsx" },
      { path: "floors_walls.png", output: "./tiled/floors_walls.png" },
      { path: "decorations.tsx", output: "./tiled/decorations.tsx" },
      { path: "decorations.png", output: "./tiled/decorations.png" },
      { path: "furniture.tsx", output: "./tiled/furniture.tsx" },
      { path: "furniture.png", output: "./tiled/furniture.png" },
    ],
  }),
  BeeClubMap: new TiledResource("./tiled/beeClub.tmx", {
    entityClassNameFactories: {
      border: (props) => {
        return new Actor({
          anchor: new Vector(0, 0),
          pos: props.worldPos,
          width: props.object.width,
          height: props.object.height,
          collisionType: CollisionType.Fixed,
        });
      },
    },
    // Path map intercepts and redirects to work around vite's static bundling
    pathMap: [
      { path: "floors_walls.tsx", output: "./tiled/floors_walls.tsx" },
      { path: "floors_walls.png", output: "./tiled/floors_walls.png" },
      { path: "decorations.tsx", output: "./tiled/decorations.tsx" },
      { path: "decorations.png", output: "./tiled/decorations.png" },
      { path: "furniture.tsx", output: "./tiled/furniture.tsx" },
      { path: "furniture.png", output: "./tiled/furniture.png" },
    ],
  }),
  MargiesMap: new TiledResource("./tiled/margies.tmx", {
    entityClassNameFactories: {
      border: (props) => {
        return new Actor({
          anchor: new Vector(0, 0),
          pos: props.worldPos,
          width: props.object.width,
          height: props.object.height,
          collisionType: CollisionType.Fixed,
        });
      },
    },
    // Path map intercepts and redirects to work around vite's static bundling
    pathMap: [
      { path: "floors_walls.tsx", output: "./tiled/floors_walls.tsx" },
      { path: "floors_walls.png", output: "./tiled/floors_walls.png" },
      { path: "decorations.tsx", output: "./tiled/decorations.tsx" },
      { path: "decorations.png", output: "./tiled/decorations.png" },
      { path: "furniture.tsx", output: "./tiled/furniture.tsx" },
      { path: "furniture.png", output: "./tiled/furniture.png" },
    ],
  }),
  FarmersMarketMap: new TiledResource("./tiled/farmersMarket.tmx", {
    entityClassNameFactories: {
      border: (props) => {
        return new Actor({
          anchor: new Vector(0, 0),
          pos: props.worldPos,
          width: props.object.width,
          height: props.object.height,
          collisionType: CollisionType.Fixed,
        });
      },
    },
    // Path map intercepts and redirects to work around vite's static bundling
    pathMap: [
      { path: "floors_walls.tsx", output: "./tiled/floors_walls.tsx" },
      { path: "floors_walls.png", output: "./tiled/floors_walls.png" },
      { path: "decorations.tsx", output: "./tiled/decorations.tsx" },
      { path: "decorations.png", output: "./tiled/decorations.png" },
      { path: "furniture.tsx", output: "./tiled/furniture.tsx" },
      { path: "furniture.png", output: "./tiled/furniture.png" },
    ],
  }),
  BillsMap: new TiledResource("./tiled/bills.tmx", {
    entityClassNameFactories: {
      border: (props) => {
        return new Actor({
          anchor: new Vector(0, 0),
          pos: props.worldPos,
          width: props.object.width,
          height: props.object.height,
          collisionType: CollisionType.Fixed,
        });
      },
    },
    // Path map intercepts and redirects to work around vite's static bundling
    pathMap: [
      { path: "homeSprites.png", output: "./tiled/homeSprites.png" },
      { path: "homeSprites.tsx", output: "./tiled/homeSprites.tsx" },
    ],
  }),
  JacksonsMap: new TiledResource("./tiled/jacksons.tmx", {
    entityClassNameFactories: {
      border: (props) => {
        return new Actor({
          anchor: new Vector(0, 0),
          pos: props.worldPos,
          width: props.object.width,
          height: props.object.height,
          collisionType: CollisionType.Fixed,
        });
      },
    },
    // Path map intercepts and redirects to work around vite's static bundling
    pathMap: [
      { path: "homeSprites.png", output: "./tiled/homeSprites.png" },
      { path: "homeSprites.tsx", output: "./tiled/homeSprites.tsx" },
    ],
  }),
  TownMap: new TiledResource("./tiled/town.tmx", {
    entityClassNameFactories: {
      border: (props) => {
        return new Actor({
          anchor: new Vector(0, 0),
          pos: props.worldPos,
          width: props.object.width,
          height: props.object.height,
          collisionType: CollisionType.Fixed,
        });
      },
    },
    // Path map intercepts and redirects to work around vite's static bundling
    pathMap: [
      { path: "homeSprites.png", output: "./tiled/homeSprites.png" },
      { path: "homeSprites.tsx", output: "./tiled/homeSprites.tsx" },
      { path: "furniture.tsx", output: "./tiled/furniture.tsx" },
      { path: "furniture.png", output: "./tiled/furniture.png" },
    ],
  }),
  CrossroadsMap: new TiledResource("./tiled/crossroads.tmx", {
    entityClassNameFactories: {
      border: (props) => {
        return new Actor({
          anchor: new Vector(0, 0),
          pos: props.worldPos,
          width: props.object.width,
          height: props.object.height,
          collisionType: CollisionType.Fixed,
        });
      },
    },
    // Path map intercepts and redirects to work around vite's static bundling
    pathMap: [
      { path: "homeSprites.png", output: "./tiled/homeSprites.png" },
      { path: "homeSprites.tsx", output: "./tiled/homeSprites.tsx" },
    ],
  }),
  Back40Map: new TiledResource("./tiled/back40.tmx", {
    entityClassNameFactories: {
      border: (props) => {
        return new Actor({
          anchor: new Vector(0, 0),
          pos: props.worldPos,
          width: props.object.width,
          height: props.object.height,
          collisionType: CollisionType.Fixed,
        });
      },
    },
    // Path map intercepts and redirects to work around vite's static bundling
    pathMap: [
      { path: "homeSprites.png", output: "./tiled/homeSprites.png" },
      { path: "homeSprites.tsx", output: "./tiled/homeSprites.tsx" },
    ],
  }),
  HoneyHouseMap: new TiledResource("./tiled/honeyHouse.tmx", {
    entityClassNameFactories: {
      border: (props) => {
        return new Actor({
          anchor: new Vector(0, 0),
          pos: props.worldPos,
          width: props.object.width,
          height: props.object.height,
          collisionType: CollisionType.Fixed,
        });
      },
    },
    // Path map intercepts and redirects to work around vite's static bundling
    pathMap: [
      { path: "homeSprites.png", output: "./tiled/homeSprites.png" },
      { path: "homeSprites.tsx", output: "./tiled/homeSprites.tsx" },
      { path: "floors_walls.tsx", output: "./tiled/floors_walls.tsx" },
      { path: "floors_walls.png", output: "./tiled/floors_walls.png" },
      { path: "decorations.tsx", output: "./tiled/decorations.tsx" },
      { path: "decorations.png", output: "./tiled/decorations.png" },
      { path: "furniture.tsx", output: "./tiled/furniture.tsx" },
      { path: "furniture.png", output: "./tiled/furniture.png" },
      { path: "interiorSprites.png", output: "./tiled/interiorSprites.png" },
      { path: "interiorSprites.tsx", output: "./tiled/interiorSprites.tsx" },
    ],
  }),
  TsxResource: new Resource("./tiled/home.tmx", "text"),
};

export const loader = new Loader();
loader.logo =
  "data:image/png;base64,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";
loader.logoWidth = 100;
loader.logoHeight = 32;
loader.logoPosition = new Vector(290, 140);
loader.loadingBarPosition = new Vector(290, 180);
loader.playButtonText = "Start BKPR";
loader.backgroundColor = Color.fromHex("#241604");
loader.loadingBarColor = Color.fromHex("#254711");
for (let resource of Object.values(Resources)) {
  loader.addResource(resource);
}
